<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :hot-key-create-path="`/supplier/create`"
    :hot-key-grid-tab-index="-1"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Supplier"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="baseView.id"
        recordType="Supplier"
      />
    </template>
    <div class="css-v2 gc-master-screen">
      <DxToolbar ref="toolbarRef" class="view-toolbar">
        <DxItem
          widget="dxForm"
          location="before"
          ref="widgetRef"
          :options="{
            formData: this.model,
            items: this.toolbarFormItems,
            validationGroup: 'toolbarForm',
            labelLocation: 'left',
            disabled: baseView.mode == 'review' ? true : false,
          }"
          locate-in-menu="auto"
          :disabled="baseView.mode == 'review' ? true : false"
        ></DxItem>
        <DxItem
          widget="dxForm"
          location="after"
          :options="{
            formData: model,
            items: toolbarActiveItems,
            validationGroup: 'toolbarActive',
            labelLocation: 'left',
            disabled: baseView.mode == 'review' ? true : false,
          }"
          locate-in-menu="after"
          :disabled="baseView.mode == 'review' ? true : false"
          v-if="dataLoaded"
        ></DxItem>

        <DxItem
          :options="toolbar.audit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
        />

        <DxItem
          :options="toolbar.edit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
        />

        <DxItem
          :options="toolbar.save"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode != 'review'"
        />

        <DxItem
          :options="toolbarEllipsis"
          location="after"
          locate-in-menu="auto"
          widget="dxDropDownButton"
          v-if="baseView.mode != 'create'"
        />
      </DxToolbar>

      <div class="view-card responsive-paddings">
        <form v-if="dataLoaded" autocomplete="new-dxform-sup-details">
          <DxForm
            :form-data.sync="model"
            :read-only="false"
            :show-colon-after-label="false"
            :show-required-mark="false"
            :show-validation-summary="false"
            :validation-group="formsConfig.validationGroup"
            label-location="left"
            :customizeItem="customizeItem"
            :items="items.items"
            :ref="'supplier-details'"
          >
            <template #supplierTypeTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #currencyTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
          </DxForm>
        </form>
      </div>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { BranchService } from "../../_services/api/sales/branch.service";
import { CurrencyService } from "../../_services/api/accounts/currency.service";
import { DxCustomRule } from "devextreme-vue/validator";
import validationEngine from "devextreme/ui/validation_engine";
import { SupplierService } from "../../_services/api/suppliers/supplier.service";
import { SupplierTypeService } from "../../_services/api/settings/suppliers/supplier-type.service";
import { FeatureStorage } from "../../_services/storage";
export default {
  props: {},
  mixins: [BaseViewMixin],
  // eslint-disable-next-line vue/no-unused-components
  components: { DxCustomRule },
  async created() {
    this.showLoading(true);
    let that = this;
    if (this.baseView.mode !== "create") {
      this.model.Code = this.baseView.id;
      await this.getSupplier().then((response) => {
        if (response.data.value.length > 0) {
          that.model.Code = response.data.value[0].Code;
          that.model.Name = response.data.value[0].Name;
          that.model.SupplierTypeCode = response.data.value[0].SupplierTypeCode;
          that.model.Discount = response.data.value[0].Discount;
          that.model.Abn = response.data.value[0].Abn;
          that.model.WithholdingTaxRate =
            response.data.value[0].WithholdingTaxRate;
          that.model.CurrencyCode = response.data.value[0].CurrencyCode;
          that.model.AccountNoWithSupplier =
            response.data.value[0].AccountNoWithSupplier;
          that.model.Phone1 = response.data.value[0].Phone1;
          that.model.Fax1 = response.data.value[0].Fax1;
          that.model.Inactive =
            response.data.value[0].Inactive == "N" ? true : false;
          that.model.AutomaticPurchase =
            response.data.value[0].AutomaticPurchase.toLowerCase() == "on"
              ? true
              : false;

          that.model.TermCalculation =
            response.data.value[0].TermCalculation.toUpperCase();
          that.model.Terms = response.data.value[0].Terms;
          that.model.ExistingTerms = response.data.value[0].Terms;
          that.model.RemittanceContactName =
            response.data.value[0].RemittanceContactName;
          that.model.RemittanceEmail = response.data.value[0].RemittanceEmail;
          that.model.BankAccountName = response.data.value[0].BankAccountName;
          that.model.Bsbno = response.data.value[0].Bsbno;
          that.model.BankAccountNo = response.data.value[0].BankAccountNo;
          that.model.PhysicalAddressStreetLine1 =
            response.data.value[0].PhysicalAddressStreetLine1;
          that.model.PhysicalAddressStreetLine2 =
            response.data.value[0].PhysicalAddressStreetLine2;
          that.model.PhysicalAddressSuburb =
            response.data.value[0].PhysicalAddressSuburb;
          that.model.PhysicalAddressState =
            response.data.value[0].PhysicalAddressState;
          that.model.PhysicalAddressPostcode =
            response.data.value[0].PhysicalAddressPostcode;
          that.model.PhysicalAddressCountry =
            response.data.value[0].PhysicalAddressCountry;
          that.model.MailAddressStreetLine1 =
            response.data.value[0].MailAddressStreetLine1;
          that.model.MailAddressStreetLine2 =
            response.data.value[0].MailAddressStreetLine2;
          that.model.MailAddressSuburb =
            response.data.value[0].MailAddressSuburb;
          that.model.MailAddressState = response.data.value[0].MailAddressState;
          that.model.MailAddressPostcode =
            response.data.value[0].MailAddressPostcode;
          that.model.MailAddressCountry =
            response.data.value[0].MailAddressCountry;
          that.model.CreatedBy = response.data.value[0].CreatedBy;
          that.model.DateCreated = response.data.value[0].DateCreated;
          that.model.ChangedBy = response.data.value[0].ChangedBy;
          that.model.DateChanged = response.data.value[0].DateChanged;
          that.model.DefaultBranchCode =
            response.data.value[0].DefaultBranchCode;

          that.refreshView();

          // This fixes up case sensitity issues with remote data in SelectBox
          if (that.$refs["supplier-details"])
            that.validateFormConfig(that.$refs["supplier-details"].instance);
        }
        that.dataLoaded = true;
        that.showLoading(false);
        this.setFocus();
      });
    }
    if (this.baseView.mode == "create") {
      this.model.Discount = 0;
      this.model.WithholdingTaxRate = 0;
      this.model.CurrencyCode = "AUD";
      this.model.AutomaticPurchase = false;
      this.model.Inactive = true;
      this.model.TermCalculation = "EOM";
      this.model.Terms = 0;
      this.model.PhysicalAddressCountry = "Australia";
      this.model.MailAddressCountry = "Australia";
      this.dataLoaded = true;
      this.showLoading(false);
    }
    this.setFocus();
  },
  watch: {
    $route(to) {
      if (to.path == "/supplier/create") {
        location.reload();
      }
    },
  },
  data() {
    return {
      toolbar: {
        edit: {
          icon: "edit",
          onClick: () => {
            this.$router.push({
              path: `/supplier/edit/${this.baseView.id}`,
            }).then(() => this.setFocus());
          },
        },
        save: {
          validationGroup: "formsData",
          ref: "saveButton",
          icon: "floppy",
          tabIndex: -1,
          onClick: async (e) => {
            this.$logger.trackEventButtonClickSave();
            let mainForm = await validationEngine.validateGroup(
              this.formsConfig.validationGroup
            );
            let toolbarForm = await validationEngine.validateGroup(
              "toolbarForm"
            );
            let toolbarActive = await validationEngine.validateGroup(
              "toolbarActive"
            );
            var value = mainForm.brokenRules.concat(
              toolbarForm.brokenRules.concat(toolbarActive.brokenRules)
            );

            if (
              mainForm.isValid &&
              toolbarForm.isValid &&
              toolbarActive.isValid
            ) {
              this.saveSupplierDetails(e);
            } else {
              this.addErrorMessagesFromValidationResult({
                brokenRules: value,
              });
              this.displayCustomValidationSummary();
              return;
            }
          },
        },
        audit: {
          icon: "clock",
          visible: function () {
            return this.baseView.mode != "create";
          },
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },

      model: {
        Code: "",
        Name: "",
        SupplierTypeCode: "",
        Discount: "",
        Abn: "",
        WithholdingTaxRate: "",
        CurrencyCode: "",
        AccountNoWithSupplier: "",
        Phone1: "",
        Fax1: "",
        AutomaticPurchase: "",
        Inactive: "",
        TermCalculation: "",
        Terms: "",
        ExistingTerms: "",
        RemittanceContactName: "",
        RemittanceEmail: "",
        BankAccountName: "",
        Bsbno: "",
        BankAccountNo: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
        PhysicalAddressState: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressCountry: "",
        MailAddressStreetLine1: "",
        MailAddressStreetLine2: "",
        MailAddressSuburb: "",
        MailAddressState: "",
        MailAddressPostcode: "",
        MailAddressCountry: "",
        CreatedBy: "",
        DateCreated: "",
        ChangedBy: "",
        DateChanged: "",
        DefaultBranchCode: "",
      },
      dataLoaded: false,
    };
  },
  computed: {
    toolbarEllipsis() {
      return {
        icon: "more",
        class: "gc-dropdown-icon-button",
        stylingMode: "text",
        showArrowIcon: false,
        tabIndex: -1,
        items: [
          {
            menuText: "Pay",
            disabled:
              this.model.Inactive &&
              FeatureStorage.checkPermission("CashPayment", "create")
                ? false
                : true,
          },
          {
            menuText: "Invoice",
            disabled: FeatureStorage.checkPermission(
              "SupplierInvoice",
              "create"
            )
              ? false
              : true,
          },
        ],
        keyExpr: "menuText",
        displayExpr: "menuText",
        dropDownOptions: { width: 100 },
        onItemClick: this.onItemClicked,
      };
    },
    toolbarFormItems() {
      return [
        {
          dataField: "Name",
          label: { text: "Name", visible: false },
          cssClass: "toolbar-supplier-label",
          editorOptions: {
            maxLength: 100,
            placeholder: "Supplier Name",
            width: 300,
          },
          validationRules: [
            {
              type: "required",
              message: "Name is required",
            },
          ],
          required: true,
        },
      ];
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "Inactive",
          gcType: "Boolean",
          gcLabel: "Active",
          editorOptions: {
            tabIndex: -1,
          },
        },
      ]);
    },
    items() {
      return {
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                items: this.parseFormColumns([
                  {
                    dataField: "PhysicalAddressStreetLine1",
                    gcLabel: "Street Line 1",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 50,
                    },
                  },
                  {
                    dataField: "PhysicalAddressStreetLine2",
                    gcLabel: "Street Line 2",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 50,
                    },
                  },
                  {
                    dataField: "PhysicalAddressSuburb",
                    gcLabel: "Suburb",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 50,
                    },
                  },
                  {
                    dataField: "PhysicalAddressState",
                    gcLabel: "State",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 100,
                    },
                  },
                  {
                    dataField: "PhysicalAddressPostcode",
                    gcLabel: "Postcode",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 20,
                    },
                  },
                  {
                    dataField: "PhysicalAddressCountry",
                    gcLabel: "Country",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 30,
                    },
                  },
                  {
                    dataField: "Phone1",
                    gcLabel: "Phone",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 15,
                    },
                  },
                ]),
              },
              {
                itemType: "group",
                // caption: "Remittances",
                items: this.parseFormColumns([
                  {
                    dataField: "Abn",
                    gcLabel: "ABN",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 20,
                    },
                  },
                  {
                    dataField: "CurrencyCode",
                    id: "currency-selectBox",
                    gcLabel: "Currency",
                    gcType: "String",
                    editorType: "dxSelectBox",
                    editorOptions: {
                      dataSource: CurrencyService.dataSourceConfig(
                        "api/Currency",
                        {
                          select: ["Code", "Description"],
                          filter: [["Inactive", "=", "N"]],
                        }
                      ),
                      itemTemplate: "currencyTemplate",
                      valueExpr: "Code",
                      displayExpr: "Description",
                      searchExpr: ["Code", "Description"],
                      searchMode: "contains",
                      showClearButton: true,
                      searchEnabled: true,
                    },
                    validationRules: [
                      {
                        type: "required",
                        message: "Currency is required",
                      },
                      {
                        type: "async",
                        validationCallback: this.currencyExistsRuleCallback,
                        message: "Currency does not exist",
                      },
                    ],
                  },
                  {
                    dataField: "TermCalculation",
                    gcLabel: "Terms Method",
                    id: "term-calculation-selectBox",
                    gcType: "String",
                    editorType: "dxSelectBox",
                    required: true,
                    editorOptions: {
                      items: [
                        {
                          value: "ACTUAL",
                          text: "ACTUAL",
                        },
                        {
                          value: "EOM",
                          text: "EOM",
                        },
                        {
                          value: "SPLIT",
                          text: "SPLIT",
                        },
                      ],
                      valueExpr: "value",
                      displayExpr: "text",
                      showClearButton: true,
                      searchEnabled: true,
                      searchMode: "contains",
                      onValueChanged: (e) => {
                        if (e.event) {
                          if (e.value == "SPLIT") {
                            this.setTerms(0);
                          } else {
                            this.setTerms(this.model.ExistingTerms);
                          }
                        }
                      },
                    },
                  },
                  {
                    dataField: "Terms",
                    gcType: "Decimal-6-0",
                    gcLabel: "Terms Days",

                    editorOptions: {
                      step: 0,
                      min: 0,
                      max: 999,
                    },
                    required: true,
                  },
                  {
                    dataField: "BankAccountName",
                    gcLabel: "Account Name",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 100,
                    },

                    validationRules:
                      this.model.Bsbno || this.model.BankAccountNo
                        ? [
                            {
                              type: "required",
                              message: "Acc Name is required",
                            },
                          ]
                        : [],
                  },
                  {
                    dataField: "Bsbno",
                    gcLabel: "BSB No.",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 7,
                    },
                    validationRules:
                      this.model.BankAccountName || this.model.BankAccountNo
                        ? [
                            {
                              type: "required",
                              message: "BSB No is required",
                            },
                          ]
                        : [],
                  },

                  {
                    dataField: "BankAccountNo",
                    gcLabel: "Acc No.",
                    gcType: "String",
                    editorType: "dxTextBox",
                    editorOptions: {
                      maxLength: 10,
                    },
                    validationRules:
                      this.model.Bsbno || this.model.BankAccountName
                        ? [
                            {
                              type: "required",
                              message: "Acc No is required",
                            },
                          ]
                        : [],
                  },
                ]),
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    itemType: "group",
                    // caption: "Physical Address",
                    items: this.parseFormColumns([
                      {
                        dataField: "SupplierTypeCode",
                        id: "supplier-type-selectBox",
                        gcLabel: "Supplier Type",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: SupplierTypeService.dataSourceConfig(
                            "api/SupplierType",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          itemTemplate: "supplierTypeTemplate",
                          valueExpr: "Code",
                          displayExpr: "Description",
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                        validationRules: [
                          {
                            type: "required",
                            message: "Supplier Type is required",
                          },
                          {
                            type: "async",
                            validationCallback:
                              this.supplierTypeExistsRuleCallback,
                            message: "Supplier Type does not exist",
                          },
                        ],
                      },
                      {
                        dataField: "DefaultBranchCode",
                        id: "default-branch-selectBox",
                        gcLabel: "Default Branch",
                        gcType: "String",
                        editorType: "dxSelectBox",
                        editorOptions: {
                          dataSource: BranchService.dataSourceConfig(
                            "api/Branch",
                            {
                              select: ["Code", "Description"],
                              filter: [["Inactive", "=", "N"]],
                              sort: [{ selector: "Description", asc: true }],
                            }
                          ),
                          valueExpr: "Code",
                          displayExpr: "Description",
                          searchExpr: ["Code", "Description"],
                          searchMode: "contains",
                          showClearButton: true,
                          searchEnabled: true,
                        },
                      },
                    ]),
                  },
                ],
              },
            ],
          },
        ],
      };
    },

    tabs() {
      if (this.baseView.mode == "create") {
        return [
          {
            text: "Details",
            path: `/supplier/review/${this.baseView.id}`,
            applicationFeatureCode: "Customer",
          },
        ];
      } else {
        return [
          {
            text: "Details",
            path: `/supplier/review/${this.baseView.id}`,
            applicationFeatureCode: "Customer",
          },
          {
            text: "Contacts",
            path: `/supplier-contact/${this.baseView.id}`,
            applicationFeatureCode: "Customer",
          },
          {
            text: "Notes",
            path: `/supplier-note/${this.baseView.id}`,
            applicationFeatureCode: "Customer",
          },
          {
            text: "Transactions",
            path: `/supplier-transaction-history/${this.baseView.id}`,
            applicationFeatureCode: "SupplierTransactionHistory",
          },
        ];
      }
    },
  },

  methods: {
    setFocus(){
      this.$nextTick(() => {
        const toolbarInstance = this.$refs["toolbarRef"].$el;
        const firstInputElement = toolbarInstance.querySelector(
            ".dx-texteditor-input"
        );
        if (firstInputElement) {
          firstInputElement.focus();
        }
      });
    },
    setTerms(termValue) {
      this.model.Terms = termValue;
      let formInstance = this.$refs["supplier-details"].instance;
      let termDays = formInstance.getEditor("Terms");

      if (termValue === 0) {
        if (termDays) {
          termDays.option("readOnly", true);
          termDays.option("tabIndex", -1);
        }
      } else {
        if (termDays) {
          termDays.option("readOnly", false);
          termDays.option("tabIndex", undefined);
        }
      }
    },
    onItemClicked(e) {
      if (e.itemData.menuText == "Pay") {
        this.$router.push({
          path: `/supplier-payment/create/${this.baseView.id}`,
          query: {
            from: "/supplier/review/" + this.baseView.id,
            SUP_ID: encodeURI(JSON.stringify(this.baseView.id)),
          },
        });
      } else {
        this.$router.push({
          path: "/supplier-invoice/create",
          query: {
            from: "supplier/review/" + this.baseView.id,
            SUP_ID: JSON.stringify(this.baseView.id),
          },
        });
      }
    },
    supplierTypeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        SupplierTypeService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.SupplierTypeCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.SupplierTypeCode = "";
            resolve(false);
          }
        });
      });
    },
    currencyExistsRuleCallback(params) {
      return new Promise((resolve) => {
        CurrencyService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.CurrencyCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.CurrencyCode = "";
            resolve(false);
          }
        });
      });
    },

    async saveSupplierDetails(e) {
      let payload = {
        Name: this.model.Name,
        Code: this.model.Code,
        SupplierTypeCode: this.model.SupplierTypeCode,
        Discount: this.model.Discount,
        Abn: this.model.Abn,
        WithholdingTaxRate: this.model.WithholdingTaxRate,
        CurrencyCode: this.model.CurrencyCode,
        AccountNoWithSupplier: this.model.AccountNoWithSupplier,
        Phone1: this.model.Phone1,
        Fax1: this.model.Fax1,
        AutomaticPurchase: this.model.AutomaticPurchase ? "On" : "Off",
        Inactive: this.model.Inactive ? "N" : "Y",
        TermCalculation: this.model.TermCalculation,
        Terms: this.model.Terms,
        RemittanceContactName: null,
        RemittanceEmail: null,
        BankAccountName: this.model.BankAccountName,
        Bsbno: this.model.Bsbno,
        BankAccountNo: this.model.BankAccountNo,
        PhysicalAddressStreetLine1: this.model.PhysicalAddressStreetLine1,
        PhysicalAddressStreetLine2: this.model.PhysicalAddressStreetLine2,
        PhysicalAddressSuburb: this.model.PhysicalAddressSuburb,
        PhysicalAddressState: this.model.PhysicalAddressState,
        PhysicalAddressPostcode: this.model.PhysicalAddressPostcode,
        PhysicalAddressCountry: this.model.PhysicalAddressCountry,
        MailAddressStreetLine1: this.model.PhysicalAddressStreetLine1,
        MailAddressStreetLine2: this.model.PhysicalAddressStreetLine2,
        MailAddressSuburb: this.model.PhysicalAddressSuburb,
        MailAddressState: this.model.PhysicalAddressState,
        MailAddressPostcode: this.model.PhysicalAddressPostcode,
        MailAddressCountry: this.model.PhysicalAddressCountry,
        DefaultBranchCode: this.model.DefaultBranchCode,
      };

      // eslint-disable-next-line no-console
      // this.$logger.debug("payload", payload);

      const result = await e.validationGroup.validate();
      // eslint-disable-next-line no-console
      // this.$logger.debug("result", result.brokenRules);
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }

      this.showLoading(true);
      await SupplierService.saveSupplier(this.baseView.mode, payload)
        .then((res) => {
          this.showLoading(false);

          if (this.baseView.mode == "create") {
            this.model.Code = res.data.Code;

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/supplier/review/${this.model.Code}`,
            });
          }
          this.$notify(
            `Supplier ${this.model.Name} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/supplier/review/${this.model.Code}`,
          });
          this.$logger.debug("response", res);
        })
        .catch((error) => {
          this.displayServerError(error, "Supplier save failed");
        });
    },

    async getSupplier() {
      return SupplierService.getByCode(this.baseView.id);
    },
    backButtonFunction() {
      this.$router.push({
        path: "/supplier",
      });
    },
  },
  mounted() {
    this.selectedIndex = 0;

    if (this.baseView.mode === "create" && this.dataLoaded) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarForm");
      validationEngine.validateGroup("toolbarActive");
    }
  },
  updated() {
    if (this.dataLoaded) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("toolbarForm");
      validationEngine.validateGroup("toolbarActive");
    }
  },
};
</script>
